const Forms = [
  {
    type: "Select",
    options: "StatusPo",
    label: "status",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "StatusPo",
    id: "StatusPo",
    datatype: "select",
    show: true,
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Select",
    options: "CustomerName",
    label: "supplier_management_form_filters_customer_supplier",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "CustomerName",
    id: "CustomerName",
    datatype: "select",
    show: true,
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Select",
    options: "SupplierName",
    label: "shipper",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "SupplierNameEuro",
    id: "SupplierNameEuro",
    datatype: "select",
    show: true,
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Select",
    options: "ConsigneeName",
    label: "consignee",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "ConsigneeName",
    id: "ConsigneeName",
    datatype: "select",
    show: true,
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Select",
    options: "TransportMode",
    label: "transport_mode",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "TransportMode",
    id: "TransportMode",
    datatype: "select",
    show: true,
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Datetime",
    label: "required_at_destination",
    name: "requireddestinationdate",
    class: "col-md-3 col-lg-3 col-sm-12",
    id: "RequiredDestinationDate",
    style: { fontWeight: "bold", fontSize: '12px' },
  },
  {
    type: "Datetime",
    label: "request_ready",
    name: "RequiredCagoReady",
    class: "col-md-3 col-lg-3 col-sm-12",
    id: "RequiredCargoReadyDate",
    style: { fontWeight: "bold", maxWidth: "60%", fontSize: '12px' },
  },
  {
    type: "Datetime",
    label: "promise_ready",
    name: "PromiseCargoReady",
    class: "col-md-3 col-lg-3 col-sm-12",
    id: "PromiseCargoReady",
    style: { fontWeight: "bold", fontSize: '12px' },
  },
];

export default Forms;
